import React from 'react';
import { TrendingUp, TrendingDown, Minus } from 'lucide-react';

interface ResultCardProps {
  title: string;
  value: number;
  description: string;
  trend: 'up' | 'down' | 'neutral';
  suffix?: string;
}

const ResultCard: React.FC<ResultCardProps> = ({ title, value, description, trend, suffix }) => {
  const formatValue = (val: number) => {
    if (suffix) {
      return `${val.toLocaleString()}${suffix}`;
    }
    return new Intl.NumberFormat('en-US', {
      style: 'currency',
      currency: 'USD',
      maximumFractionDigits: 0,
    }).format(val);
  };

  const getTrendIcon = () => {
    switch (trend) {
      case 'up':
        return <TrendingUp className="h-5 w-5 text-emerald-700" aria-hidden="true" />;
      case 'down':
        return <TrendingDown className="h-5 w-5 text-red-700" aria-hidden="true" />;
      default:
        return <Minus className="h-5 w-5 text-gray-700" aria-hidden="true" />;
    }
  };

  return (
    <div className="bg-white rounded-lg p-4 shadow" role="region" aria-label={title}>
      <div className="flex items-center justify-between">
        <h3 className="text-sm font-medium text-gray-700">{title}</h3>
        {getTrendIcon()}
      </div>
      <p className="mt-2 text-lg sm:text-2xl font-semibold text-gray-900 break-words">
        {formatValue(value)}
      </p>
      <p className="mt-1 text-xs sm:text-sm text-gray-700">{description}</p>
    </div>
  );
};

export default ResultCard;